<template lang="pug">
  v-col(cols="12")
    v-card(class="sdo-card")
      div.d-flex(v-if="categoriesLoading")
        v-skeleton-loader.ma-4(
          v-for="n in 4"
          :key="`skeleton${n}`"
          min-width="122"
          max-height="110"
          type="image"
        )
      v-slide-group(v-if="!categoriesLoading" v-model="selectedFolder")
        v-slide-item(key="all" v-slot="{ active, toggle }")
          v-card(
            class="ma-4 card-folder"
            @click="toggle"
            :ripple="false"
            :class="{ 'folder--active': !selectedFolder }"
            flat
          )
            v-card-title(class="pa-0 px-1 align-start pt-2 card-folder justify-center")
              folder-icon(static)
            v-card-text.pa-0.px-2 Все задания
        v-slide-item(key="no_cat" v-slot="{ active, toggle }" value="no_category")
          v-card(
            class="ma-4 card-folder"
            @click="toggle"
            :ripple="false"
            :class="{ 'folder--active': active }"
            flat
          )
            v-card-title(class="pa-0 px-1 align-start pt-2 card-folder justify-center")
              folder-icon(static)
            v-card-text.pa-0.px-2 Без категории
        v-slide-item(v-for="c in categories" :key="c.id" :value="c.id" v-slot="{ active, toggle }")
          v-card(
            class="ma-4"
            @click="toggle"
            :ripple="false"
            :class="{ 'folder--active': active }"
            flat
          )
            v-card-title(class="pa-0 px-1 align-start pt-2 card-folder justify-center")
              folder-icon(@on-drop="dropToFolder($event, c.id)")
              v-btn(
                @click.prevent.stop="c.showDelete = true"
                class="delete-folder-btn"
                color="error"
                fab depressed
              )
                v-icon(small) mdi-close
              v-btn(
                @click.prevent.stop="openEditDialog(c)"
                class="edit-folder-btn"
                color="warning"
                fab depressed
              )
                v-icon(small) mdi-pencil
              delete-dialog(
                v-model="c.showDelete"
                :request-id="c.id"
                :request="$api.categories.deleteCategory"
                @delete="deleteFolder($event)"
              )
            v-spacer
            v-card-text.pa-0.px-2.text-center {{ c.name }}
        v-slide-item(key="new")
          v-card(class="ma-4 new-folder" @click="showCreateFolderDialog = true" flat)
            v-card-title(class="pa-0 px-1 align-start pt-2 card-folder justify-center")
              folder-icon(@on-drop="dropToFolder($event, c.id)")
            v-spacer
            v-card-text.pa-0.px-2 Создать папку

    create-task-folder-dialog(
      v-model="showCreateFolderDialog"
      :edit-folder-data="editFolderData"
      @on-folder-create="onFolderCreate($event)"
      @on-folder-edit="onFolderEdit($event)"
    )

</template>

<script>
import draggable from 'vuedraggable';
import SdoDialog from '@/components/Global/SdoDialog.vue';
import CreateTaskFolderDialog from '@/modules/Tasks/components/CreateTaskFolderDialog.vue';
import FolderIcon from '@/components/Icons/FolderIcon.vue';

export default {
  name: 'TaskListFolders',
  components: {
    FolderIcon,
    CreateTaskFolderDialog,
    SdoDialog,
    draggable,
  },
  props: {
    removeTask: { type: Function, required: true },
  },
  data() {
    return {
      categories: [],
      categoriesLoading: true,
      selectedFolder: null,
      showCreateFolderDialog: false,
      showDeleteFolderDialog: false,
      editFolderData: null,
      deleteLoading: false,
    };
  },
  watch: {
    selectedFolder(val) {
      this.$emit('folder-select', val);
    },
  },
  mounted() {
    this.getFolders();
  },
  methods: {
    getFolders() {
      this.categoriesLoading = true;
      this.$rHandler(
        this.$api.categories.getCategories(),
        (r) => {
          this.categories = r.data.data;
          this.categories.forEach((c) => {
            this.$set(c, 'showDelete', false);
          });
          this.categoriesLoading = false;
        },
        () => {
          this.categoriesLoading = false;
        },
      );
    },
    dropToFolder(e, folderId) {
      const taskId = Number(e.dataTransfer.getData('text'));
      const items = [taskId];
      this.$rHandler(
        this.$api.categories.bindItemsToCategory(folderId, 'task', items),
        () => {
          this.removeTask(taskId);
          this.$toasted.success('Задание загружено в папку', {
            duration: 3000,
            icon: 'mdi-check',
          });
        },
      );
    },
    onFolderCreate(folder) {
      this.categories.push(folder);
    },
    onFolderEdit(folder) {
      const editedFolder = this.categories.find((c) => c.id === folder.id);
      editedFolder.name = folder.name;
      this.editFolderData = null;
    },
    deleteFolder(folderId) {
      this.categories = this.categories.filter((c) => c.id !== folderId);
    },
    openEditDialog(folder) {
      this.editFolderData = folder;
      this.showCreateFolderDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .v-card--link:focus:before {
  opacity: 0;
}

::v-deep .icon-container {
  width: 90px;
}

.folder-container {
  position:absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.folder--active {
  transition: all .3s;
  background: rgba(0,0,0,.07);
}

.new-folder {
  border: 1px dashed #aaa;
  opacity: .7;
}

.delete-folder-btn {
  z-index:1000;
  position: absolute;
  top: 5px;
  right: 5px;
  height: 24px;
  width: 24px;
  opacity: 0;
}

.edit-folder-btn {
  z-index:1000;
  position: absolute;
  top: 5px;
  right: 33px;
  height: 24px;
  width: 24px;
  opacity: 0;
}

.card-folder:hover {
  .delete-folder-btn,
  .edit-folder-btn {
    opacity: 1;
  }
}
</style>
